import { useMemo } from 'react';
import { useMutation } from 'react-query';
import AffordableWaitlistService from '../../../services/affordableWaitlistService';

export const useSelectFromWaitlist = ({
  organizationId,
  propertyId,
  options,
}) => {
  const affordableWaitlistService = useMemo(
    () => new AffordableWaitlistService(),
    [],
  );
  const mutation = useMutation(
    ({ payload, affordableWaitlistId }) =>
      affordableWaitlistService.selectFromWaitlist(
        organizationId,
        propertyId,
        affordableWaitlistId,
        payload,
      ),
    options,
  );

  return {
    ...mutation,
  };
};

export default useSelectFromWaitlist;
